export const filterMoldeExamPractice = (row: any) => {
  if (!row || !row?.metadata || Object.keys(row?.metadata)?.length === 0) return null;
  if (!row?.metadata?.exam && !row?.metadata?.molde) {
    const practices = row?.metadata?.practices?.map((e: any) => e.name);
    return <p className="">
      <ul className="">
        {practices.map((e: any, i:any) => (
          <li className="p-1" key={i}>-{e}</li>
        ))}
      </ul>
    </p>;
  }

  if (row?.metadata?.molde) return `-${row?.metadata?.molde?.name}`;
  return `-${row?.metadata?.exam?.name}`;
};